import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import IconArrowDown from '../../../vectors/IconArrowDown'

const SelectWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 40px 12px 42px;
  background-color: ${(props) => props.theme.colors.blue_light};
  border-top: 1px solid ${(props) => props.theme.colors.grey_op10};
`

const FilterLabel = styled.div`
  font-size: 16px;
  color: ${(props) => props.theme.colors.blue};
  font-weight: 600;
`

const ValueLabel = styled.div`
  font-size: 16px;
  color: ${(props) => props.theme.colors.grey_op80};
`

const StyledSelect = styled.select`
  position: absolute;
  width: 100%;
  height: 100%;
  appearance: none;
  opacity: 0;
  left: 0;

  border: none;
  border-radius: 4px;
  &:focus {
    outline: none;
  }
`

const ChevronIcon = styled.div`
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;

  svg {
    position: relative;
    top: 3px;
    width: 16px;
    height: 16px;
    fill: ${(props) => props.theme.colors.blue};
  }
`

export const ContentBrandFilter = ({
  options,
  value,
  onSelect,
  label = 'Brand'
}) => {
  const handleChange = (event) => {
    onSelect(event.target.value)
  }

  return (
    <SelectWrapper>
      <ChevronIcon>
        <IconArrowDown />
      </ChevronIcon>
      <FilterLabel>{label}</FilterLabel>
      <StyledSelect value={value} onChange={handleChange}>
        {options &&
          options.length > 0 &&
          options.map(({ label, value }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
      </StyledSelect>
      <ValueLabel>{value || 'Any'}</ValueLabel>
    </SelectWrapper>
  )
}

ContentBrandFilter.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  value: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  placeholder: PropTypes.string
}
